import { map } from 'rxjs/operators';

export function all(value: boolean) {
  return map<boolean[], boolean>(list => list.every(v => v === value));
}
